import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

type TBlockInfo = {
  description: string;
  id: number;
  isAuto: boolean;
  name: string;
};

type TInitialValuesBlocked = {
  divisionId: string;
  search: string;
  personnelNumber: string;
  blockedInfo: Record<number, TBlockInfo>;
};

const initialState: TInitialValuesBlocked = {
  divisionId: '',
  search: '',
  personnelNumber: '',
  blockedInfo: {},
};

export const blockedSlice = createSlice({
  name: 'ui/controls/blocked',
  initialState,
  reducers: {
    divisionId(state, { payload }: PayloadAction<string>) {
      return { ...state, divisionId: payload };
    },
    search(state, { payload }: PayloadAction<string>) {
      return { ...state, search: payload };
    },
    personnelNumber(state, { payload }: PayloadAction<string>) {
      return { ...state, personnelNumber: payload };
    },
    setBlockInfo(state, { payload }: PayloadAction<{ userId: number; blockInfo: TBlockInfo }>) {
      const { userId, blockInfo } = payload;
      return { ...state, blockedInfo: { ...state.blockedInfo, [userId]: blockInfo } };
    },
    clearBlockInfo(state) {
      return { ...state, blockedInfo: {} };
    },
  },
});

const selectBlocked = (state: RootState) => state.ui.blockedEmployees;

const getBlockInfo = createSelector(selectBlocked, state => state.blockedInfo);

export const selectors = { selectBlocked, getBlockInfo };
export const actions = blockedSlice.actions;
export const reducer = blockedSlice.reducer;
